import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Card } from '../components/ui/Card';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0A0E27]">
      <Header />
      
      <main className="pt-20 pb-20">
        <div className="container mx-auto px-6 py-12 max-w-4xl">
          <Card className="p-8 md:p-12">
            <h1 className="text-4xl font-bold mb-8 gradient-text">Política de Privacidade</h1>
            
            <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
              <p className="text-sm text-gray-400 italic">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">1. Introdução</h2>
                <p>
                  Esta Política de Privacidade descreve como o Video Analyzer IA ("nós", "nosso" ou "plataforma") coleta, 
                  usa, armazena e protege suas informações pessoais quando você utiliza nosso serviço. Respeitamos sua 
                  privacidade e estamos comprometidos em proteger seus dados pessoais.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">2. Informações que Coletamos</h2>
                
                <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.1. Informações de Autenticação</h3>
                <p>
                  Utilizamos o serviço de autenticação Clerk para gerenciar contas de usuários. As informações coletadas incluem:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Endereço de e-mail</li>
                  <li>Nome de usuário (se fornecido)</li>
                  <li>Dados de autenticação fornecidos ao Clerk</li>
                </ul>
                <p className="mt-3">
                  O Clerk processa essas informações de acordo com sua própria política de privacidade. Recomendamos que você 
                  revise a política de privacidade do Clerk em: <a href="https://clerk.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">https://clerk.com/privacy</a>
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.2. Dados de Uso</h3>
                <p>Coletamos informações sobre como você utiliza nossa plataforma:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>URLs de vídeos analisados</li>
                  <li>Histórico de análises realizadas</li>
                  <li>Data e hora das análises</li>
                  <li>Status das análises (processando, concluída, falhou)</li>
                  <li>Transcrições de vídeos (para fins de análise)</li>
                </ul>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.3. Informações de Pagamento</h3>
                <p>
                  Para processamento de pagamentos de créditos, utilizamos o Stripe. As informações de pagamento (número de cartão, 
                  dados bancários, etc.) são processadas exclusivamente pelo Stripe e não são armazenadas em nossos servidores.
                </p>
                <p className="mt-3">
                  Recomendamos que você revise a política de privacidade do Stripe em: <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">https://stripe.com/privacy</a>
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.4. Dados Técnicos</h3>
                <p>Podemos coletar automaticamente:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Endereço IP</li>
                  <li>Tipo de navegador e versão</li>
                  <li>Sistema operacional</li>
                  <li>Páginas visitadas e tempo de permanência</li>
                  <li>Referrers (origem do acesso)</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">3. Como Utilizamos suas Informações</h2>
                <p>Utilizamos suas informações pessoais para:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Fornecimento do Serviço:</strong> Processar análises de vídeos e manter seu histórico</li>
                  <li><strong>Autenticação:</strong> Gerenciar seu acesso à plataforma</li>
                  <li><strong>Gerenciamento de Créditos:</strong> Controlar seu saldo de créditos e processar compras</li>
                  <li><strong>Melhoria do Serviço:</strong> Analisar padrões de uso para melhorar a funcionalidade</li>
                  <li><strong>Comunicação:</strong> Enviar notificações sobre o status das análises e atualizações importantes</li>
                  <li><strong>Segurança:</strong> Prevenir fraudes, abusos e garantir a segurança da plataforma</li>
                  <li><strong>Conformidade Legal:</strong> Cumprir obrigações legais e regulatórias</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">4. Compartilhamento de Informações</h2>
                <p>Não vendemos suas informações pessoais. Podemos compartilhar seus dados apenas nas seguintes situações:</p>
                
                <h3 className="text-xl font-semibold text-white mt-6 mb-3">4.1. Prestadores de Serviços</h3>
                <p>Compartilhamos dados com:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Clerk:</strong> Para autenticação e gerenciamento de usuários</li>
                  <li><strong>Stripe:</strong> Para processamento de pagamentos</li>
                  <li><strong>Provedores de Hospedagem:</strong> Para operação da plataforma (ex: Coolify, Hostinger)</li>
                  <li><strong>Serviços de IA:</strong> Para processamento de análises (ex: OpenAI)</li>
                </ul>
                <p className="mt-3">
                  Todos os prestadores de serviços são contratualmente obrigados a proteger suas informações e utilizá-las 
                  apenas para os fins especificados.
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">4.2. Requisitos Legais</h3>
                <p>
                  Podemos divulgar informações se necessário para cumprir leis, regulamentos, processos legais ou solicitações 
                  governamentais, ou para proteger nossos direitos, propriedade ou segurança, bem como a de nossos usuários.
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">4.3. Consentimento</h3>
                <p>
                  Compartilharemos informações com terceiros quando você fornecer consentimento explícito para tal.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">5. Armazenamento e Segurança</h2>
                
                <h3 className="text-xl font-semibold text-white mt-6 mb-3">5.1. Localização dos Dados</h3>
                <p>
                  Seus dados são armazenados em servidores seguros. Os dados podem ser armazenados em servidores localizados 
                  no Brasil ou em outros países, sempre em conformidade com as leis aplicáveis de proteção de dados.
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">5.2. Medidas de Segurança</h3>
                <p>Implementamos medidas técnicas e organizacionais adequadas para proteger seus dados:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Criptografia de dados em trânsito (HTTPS/TLS)</li>
                  <li>Criptografia de dados sensíveis em repouso</li>
                  <li>Controles de acesso rigorosos</li>
                  <li>Monitoramento de segurança e detecção de ameaças</li>
                  <li>Backups regulares e planos de recuperação</li>
                </ul>
                <p className="mt-3">
                  No entanto, nenhum método de transmissão pela internet ou armazenamento eletrônico é 100% seguro. 
                  Embora nos esforcemos para proteger seus dados, não podemos garantir segurança absoluta.
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">5.3. Retenção de Dados</h3>
                <p>
                  Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir os propósitos descritos nesta 
                  política, salvo quando um período de retenção mais longo for exigido ou permitido por lei. Histórico de análises 
                  é mantido para permitir que você acesse resultados anteriores.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">6. Seus Direitos</h2>
                <p>De acordo com a LGPD (Lei Geral de Proteção de Dados), você tem os seguintes direitos:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Acesso:</strong> Solicitar acesso aos seus dados pessoais que possuímos</li>
                  <li><strong>Correção:</strong> Solicitar correção de dados incompletos, inexatos ou desatualizados</li>
                  <li><strong>Exclusão:</strong> Solicitar exclusão de dados desnecessários, excessivos ou não tratados em conformidade com a LGPD</li>
                  <li><strong>Portabilidade:</strong> Solicitar a portabilidade dos seus dados para outro prestador</li>
                  <li><strong>Revogação de Consentimento:</strong> Revogar seu consentimento a qualquer momento</li>
                  <li><strong>Oposição:</strong> Opor-se ao tratamento de dados em certas circunstâncias</li>
                  <li><strong>Informação:</strong> Ser informado sobre compartilhamento de dados</li>
                </ul>
                <p className="mt-3">
                  Para exercer esses direitos, entre em contato conosco através dos canais de suporte da plataforma.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">7. Cookies e Tecnologias Similares</h2>
                <p>
                  Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar o uso da plataforma e 
                  personalizar conteúdo. Você pode gerenciar suas preferências de cookies através das configurações do seu navegador.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">8. Privacidade de Menores</h2>
                <p>
                  Nossa plataforma não é direcionada a menores de 18 anos. Não coletamos intencionalmente informações pessoais 
                  de menores. Se tomarmos conhecimento de que coletamos dados de um menor, tomaremos medidas para excluir essas 
                  informações imediatamente.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">9. Alterações nesta Política</h2>
                <p>
                  Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre mudanças significativas 
                  através de avisos na plataforma ou por e-mail. Recomendamos que revise esta política regularmente.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">10. Contato e Encarregado de Dados</h2>
                <p>
                  Para questões sobre esta Política de Privacidade, exercício de seus direitos ou tratamento de dados pessoais, 
                  entre em contato através dos canais de suporte da plataforma.
                </p>
                <p className="mt-3">
                  Se você está localizado no Brasil, também pode entrar em contato com a Autoridade Nacional de Proteção de Dados 
                  (ANPD) caso tenha preocupações sobre o tratamento de seus dados pessoais.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">11. Transferências Internacionais</h2>
                <p>
                  Seus dados podem ser transferidos e processados em países diferentes do seu país de residência. Quando transferimos 
                  dados, garantimos que existam salvaguardas adequadas em conformidade com as leis de proteção de dados aplicáveis.
                </p>
              </section>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
}
